import {
  alpha,
  Box,
  Divider,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import theme, { responsiveFontSize } from "themes/Theme";
import { navigationData } from "./navigationData";
import { Logo } from "assets/index";

interface IProps {
  toggleDrawer: () => void;
  open: boolean;
  isMobile: boolean;
  logoutModal: () => void;
}

export const drawerWidth = "20%";

const Sidebar: React.FC<IProps> = ({
  toggleDrawer,
  open,
  isMobile,
  logoutModal,
}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const getActiveListItem = (path: string) => {
    if (pathname.includes("/admin/transactions/")) {
      return "/admin/transactions";
    } else if (pathname.includes("/admin/wallet/")) {
      return "/admin/wallet";
    } else if (pathname.includes("/admin/users/")) {
      return "/admin/users";
    } else if (pathname === "/admin/user/create") {
      return "/admin/users";
    }
    return path;
  };

  const drawerContent = (
    <Box onClick={toggleDrawer} sx={{ textAlign: "center" }}>
      <Stack
        direction={"row"}
        alignItems={"center"}
        justifyContent={"center"}
        gap={1}
        sx={{ py: 1 }}
      >
        <Box component={"img"} src={Logo} sx={styles.logoIcon} />
        <Typography
          sx={{
            color: theme.palette.common.white,
            fontSize: responsiveFontSize(18),
            mr: 5,
          }}
        >
          ERC Wallet
        </Typography>
      </Stack>
      <Divider
        sx={{
          borderColor: alpha(theme.palette.common.white, 0.3),
        }}
      />
      <List>
        {navigationData.map((text) => (
          <ListItemButton
            key={text.label}
            sx={{
              backgroundColor:
                getActiveListItem(pathname) === text.path
                  ? theme.palette.primary.main
                  : "transparent",
              ":hover": {
                backgroundColor: alpha(theme.palette.primary.light, 0.1),
              },
              borderRadius: "1em",
              mx: 1,
              mb: 1,
            }}
            onClick={() => {
              if (text.label === "Logout") {
                logoutModal();
              } else {
                navigate(text.path);
              }
            }}
          >
            <ListItemIcon
              sx={
                getActiveListItem(pathname) === text.path
                  ? styles.listItemIconStyle
                  : styles.defaultListItemIconStyle
              }
            >
              {text.icon}
            </ListItemIcon>
            <ListItemText
              primary={text.label}
              sx={
                getActiveListItem(pathname) === text.path
                  ? styles.listItemTextStyle
                  : styles.defaultListItemTextStyle
              }
            />
          </ListItemButton>
        ))}
      </List>
    </Box>
  );

  return isMobile ? (
    <Drawer
      variant="temporary"
      open={open}
      onClose={toggleDrawer}
      ModalProps={{ keepMounted: true }}
      sx={{
        display: { xs: "block", sm: "none" },
        "& .MuiDrawer-paper,.MuiDrawer-root": {
          boxSizing: "border-box",
          width: "60%",
          backgroundColor: theme.palette.primary.dark,
          borderRight: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
        },
      }}
    >
      {drawerContent}
    </Drawer>
  ) : (
    <Drawer
      variant="permanent"
      sx={{
        display: { xs: "none", sm: "block" },
        "& .MuiDrawer-paper": {
          boxSizing: "border-box",
          width: drawerWidth,
          backgroundColor: theme.palette.primary.dark,
          borderRight: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
        },
      }}
      open
    >
      {drawerContent}
    </Drawer>
  );
};
export default Sidebar;

const styles = {
  defaultListItemTextStyle: {
    fontSize: responsiveFontSize(16),
    color: alpha(theme.palette.common.white, 0.6),
  },
  listItemTextStyle: {
    fontSize: responsiveFontSize(16),
    color: theme.palette.common.white,
  },
  listItemIconStyle: {
    color: theme.palette.common.white,
  },
  defaultListItemIconStyle: {
    color: alpha(theme.palette.common.white, 0.6),
  },
  logoIcon: {
    width: 50,
    height: 50,
    objectFit: "contain",
  },
};
